import React from 'react';
import PropTypes from 'prop-types';

const FrameContainerHeader = ({ icon, subtitle, title }) => (
  <div className="bg-brand-dark [background-image:url(https://joybird2.imgix.net/user-uploads-staging/joybird-teal-new.jpg?w=400&cs=srgb)] bg-cover items-center flex flex-col -mt-5 -mx-5 mb-10 px-8 py-6 md:rounded-none md:mt-[-41px] md:mx-[-41px] md:mb-10 md:pb-8">
    {!!icon && <div className="FrameContainerHeader__icon">{icon}</div>}

    {!!title && (
      <div className="text-center text-2xl font-bold text-white mt-4">
        {title}
      </div>
    )}

    {!!subtitle && (
      <div className="text-center text-white text-sm">{subtitle}</div>
    )}
  </div>
);

FrameContainerHeader.propTypes = {
  icon: PropTypes.node,
  subtitle: PropTypes.node,
  title: PropTypes.node,
};

export default FrameContainerHeader;
